import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import { artist } from "../mock";

const Footer = () => {

  return (
    <footer className="relative z-10 border-t border-stone-800 bg-[#1A1A1A] text-stone-200">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <Link to="/" className="font-display text-2xl text-[#F7F3ED] block">
              Christina Bellaro
            </Link>
            <p className="font-mono-label text-stone-300 mt-3">Sr. Graphic Designer · {artist.location}</p>
            <p className="text-stone-200 mt-6 max-w-md">
              Two decades of brand, campaign, and editorial design for teams that care about the craft.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-label text-stone-300 mb-5">Navigate</p>
            <ul className="space-y-3">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/clients" className="link-underline">Clients</Link></li>
              <li><Link to="/about" className="link-underline">About</Link></li>
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-label text-stone-300 mb-5">Elsewhere</p>
            <ul className="space-y-3">
              <li>
                <a href={artist.socials.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline">
                  <Linkedin size={16} /> LinkedIn
                </a>
              </li>
              <li>
                <a href={`mailto:${artist.email}`} className="inline-flex items-center gap-2 link-underline">
                  <Mail size={16} /> Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-stone-400 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono-label text-stone-300">
            &copy; {new Date().getFullYear()} Christina Bellaro. All Rights Reserved.
          </p>
          <p className="font-mono-label text-stone-300">
            Based in {artist.location}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
